import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CircularProgress from '@mui/material/CircularProgress';

const useStyles = makeStyles((theme) => ({
  button: {
    display: 'inline-flex',
    whiteSpace: 'nowrap',
    transition: 'all .24s ease-in-out',
    position: 'relative',
    height: '56px',
    lineHeight: '56px',
    padding: '0px !important',
    color: '#fff !important',
    backgroundColor: ({ disabled }) => (disabled ? '#9b9b9b !important' : '#7b5599 !important'),
    fontSize: '18px !important',
    width: ({ width }) => width || 'auto',
    '& > span': {
      display: 'block',
      [theme.breakpoints.down('sm')]: {
        padding: '0 5px',
      },
      padding: '0 24px',
      flexGrow: 1,
    },
  },
  arrow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '48px',
    height: '56px',
    backgroundColor: 'hsla(0,0%,100%,.15) !important',
  },
}));

const PlanningButton = ({
  text,
  onClick,
  variant = 'contained',
  color = 'secondary',
  isLoading,
  disabled,
  width,
}) => {
  const classes = useStyles({ width, disabled });

  return (
    <Button
      className={classes.button}
      variant={variant}
      color={color}
      onClick={onClick}
      disabled={disabled}
    >
      <span className={classes.buttonText}>{text}</span>
      <div className={classes.arrow}>
        {isLoading ? (
          <CircularProgress color="inherit" size="25px" />
        ) : (
          <ChevronRightIcon />
        )}
      </div>
    </Button>
  );
};

PlanningButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.string,
  color: PropTypes.string,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  width: PropTypes.string,
};

export default PlanningButton;
